import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    keyword: ""
};

const appsSlice = createSlice({
    name: "apps",
    initialState,
    reducers: {
        setKeyword: (state, action) => {
            state.keyword = action.payload;
        },
        resetAppsFilter: (state) => {
            state.keyword = initialState.keyword;
        }

    }
});

export const { setKeyword, resetAppsFilter } = appsSlice.actions;

export default appsSlice.reducer;

